import { render } from "./SocialstyrelsenGenericTrends.vue?vue&type=template&id=5628eae4&scoped=true"
import script from "./SocialstyrelsenGenericTrends.vue?vue&type=script&lang=js"
export * from "./SocialstyrelsenGenericTrends.vue?vue&type=script&lang=js"

import "./SocialstyrelsenGenericTrends.vue?vue&type=style&index=0&id=5628eae4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5628eae4"]])

export default __exports__